import React from "react";
import SedeContextType from "./SedeContextType";
import SedeEntity from "../../entities/SedeEntity";

const SedeContext = React.createContext<SedeContextType>({
    sedes: [],
    setSedes: (sedes: SedeEntity[]) => {},
});

export default SedeContext;
